// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PtXxK","section":"styles_section__YRZxb","button":"styles_button__FuGGt"};